import React, { createContext, useState, useEffect, useContext } from 'react'
import axios from 'axios'
import config from '../config/config'
import { useTranslation } from 'react-i18next'
import { setFlashMessage } from './WebsiteContext'

const PoisContext = createContext()

export const PoisProvider = ({ children }) => {
  const { t } = useTranslation()

  const [pois, setPois] = useState([])
  const [poiTypes, setPoiTypes] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [poisRes, poiTypesRes] = await Promise.all([
          axios.get(`${config.apiUrl}poi`),
          axios.get(`${config.apiUrl}poi-type`),
        ])

        setPois(poisRes.data)
        setPoiTypes(poiTypesRes.data)
      } catch (error) {
        console.error('Failed to fetch POIs or POI types:', error)
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchData()
  }, [t])

  return (
    <PoisContext.Provider value={{ pois, setPois, poiTypes, setPoiTypes }}>
      {children}
    </PoisContext.Provider>
  )
}

export const usePois = () => {
  const context = useContext(PoisContext)
  if (!context) {
    throw new Error('usePois must be used within a PoisProvider')
  }
  return context
}
